import { ChangeDetectionStrategy, Component, DestroyRef, EventEmitter, Inject, Output } from '@angular/core';
import { WarningDelete } from '../../../models/warning-delete';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DynamicDialogButtonType } from '@gea/digital-ui-lib';

@Component({
  selector: 'app-delete-validator',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  templateUrl: './delete-validator.component.html',
  styleUrls: ['./delete-validator.component.scss']
})
export class DeleteValidatorComponent {

}
